import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";
import { cn } from "@/lib/utils";

const SlimTabs = TabsPrimitive.Root;

const SlimTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("flex h-9 items-center border-b border-olive-3", className)}
    {...props}
  />
));
SlimTabsList.displayName = "SlimTabsList";

interface SlimTabsTriggerProps
  extends React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> {
  icon?: React.ReactNode;
}

const SlimTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  SlimTabsTriggerProps
>(({ className, icon, children, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground transition-colors hover:bg-muted/40 data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-foreground data-[state=active]:shadow-none",
      "hover:cursor-pointer hover:bg-olive-4",
      className,
    )}
    {...props}
  >
    {icon}
    {children}
  </TabsPrimitive.Trigger>
));
SlimTabsTrigger.displayName = "SlimTabsTrigger";

const SlimTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn("mt-4 focus-visible:outline-none", className)}
    {...props}
  />
));
SlimTabsContent.displayName = "SlimTabsContent";

export { SlimTabs, SlimTabsList, SlimTabsTrigger, SlimTabsContent };
